export default __webpack_public_path__ + "static/media/neuheiten-2025.1534bed9.webp";